import { render, staticRenderFns } from "./LogoutAs.vue?vue&type=template&id=ef769d60&scoped=true&"
import script from "./LogoutAs.vue?vue&type=script&lang=js&"
export * from "./LogoutAs.vue?vue&type=script&lang=js&"
import style0 from "./LogoutAs.vue?vue&type=style&index=0&id=ef769d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef769d60",
  null
  
)

export default component.exports